import { useState, useEffect } from 'react';
import WalletStore from '../stores/walletStore';

export default function useWallet() {
    const [walletInfo, setWalletInfo] = useState(WalletStore.getWalletInfo());
    const [isLoading, setIsLoading] = useState(true);
    const [showBalance, setShowBalance] = useState(
        localStorage.getItem('showBalance') !== null ? Boolean(localStorage.getItem('showBalance')) : true
    );

    function getWalletInfo() {
        setWalletInfo(WalletStore.getWalletInfo());
        setIsLoading(false);
    }

    async function refreshWalletInfo() {
        setIsLoading(true);
        await WalletStore.getWalletInfofromServer();
        setIsLoading(false);
    }

    function onShowBalanceClick(e) {
        const checked = e.target.checked;
        localStorage.setItem('showBalance', checked ? true : '');
        setShowBalance(checked);
    }

    // subscribe WalletInfo
    useEffect(() => {
        WalletStore.subscribeWalletInfo(getWalletInfo);
        return () => WalletStore.unSubscribeWalletInfo(getWalletInfo);
    }, []);

    useEffect(() => {
        const intervalID = setInterval(refreshWalletInfo, 60 * 1000);
        return () => clearInterval(intervalID);
    }, []);

    return {
        isLoading,
        walletInfo,
        refreshWalletInfo,
        showBalance,
        onShowBalanceClick
    };
}